import * as React from 'react';
import { Icon, IconProps, Tooltip, Whisper } from 'rsuite';
import { WhisperProps } from 'rsuite/lib/Whisper';

export interface InfoProps {
  icon?: IconProps['icon'];
  children?: React.ReactElement;
}

function Help({
  placement = 'right',
  icon = 'help-o',
  children,
  ...props
}: InfoProps & WhisperProps) {
  return (
    <Whisper placement={placement} speaker={<Tooltip>{children}</Tooltip>} {...props}>
      <Icon className="form-filed-description-icon" icon={icon} />
    </Whisper>
  );
}

export default Help;
